import { jsx as a } from "react/jsx-runtime";
import { av as o } from "../../../vendor-EQDp64ng.js";
import '../../../assets/index39.css';const r = "_separator_18e5c_1", e = {
  separator: r
}, p = () => /* @__PURE__ */ a(o, { className: e.separator, orientation: "horizontal" });
export {
  p as Separator
};
